import Button from "@mui/material/Button";
import { paths } from "config/paths";
import Link from "next/link";
import * as React from "react";
import { DashboardContentLayout } from "~ui-components/components/atoms/dashboard-content-layout";
import {
	PaidUserAccount,
	TrialUserAccount,
} from "~ui-components/components/organisms/user-accounts";
import { CancelSubscription } from "~ui-components/components/organisms/user-accounts/cancel-subscription";
import {
	Account as AccountGql,
	AccountUsageStats,
	SUBSCRIPTION_TYPE,
	User,
} from "~ui-components/types/__generated/gql/graphql";
import { useWebRouter } from "~utils/next-router/use-web-router";

export interface AccountProps {
	user: User;
	account: AccountGql;
	accountUsageStats: AccountUsageStats;
}

export const Account: React.FC<AccountProps> = (props) => {
	const router = useWebRouter();
	const { account } = props;

	return (
		<DashboardContentLayout
			pageTitle="Account"
			action={
				<Button
					variant="contained"
					component={Link}
					href={paths.accountName.settings.editSubscription(
						router._query.accountName,
					)}>
					Manage subscription
				</Button>
			}>
			{account.subscription.type === SUBSCRIPTION_TYPE.TRIAL && (
				<TrialUserAccount {...props} />
			)}

			{account.subscription.type === SUBSCRIPTION_TYPE.PAID && (
				<PaidUserAccount {...props} />
			)}

			{account.subscription.type !== SUBSCRIPTION_TYPE.TRIAL && (
				<CancelSubscription />
			)}
		</DashboardContentLayout>
	);
};
